import { render, staticRenderFns } from "./TrangXemDanhMucMenuHeThong.vue?vue&type=template&id=dec0130c&"
import script from "./TrangXemDanhMucMenuHeThong.vue?vue&type=script&lang=js&"
export * from "./TrangXemDanhMucMenuHeThong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports